import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmAlertModule, MmButtonModule, MmDialogModule, MmIconModule } from '@metromarkets/components';

import { AdvancedFormModule } from '~shared/modules/advanced-form/advanced-form.module';

import EmployeeOverviewNavigationAlertDialogComponent from './employee-overview-navigation-alert-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmDialogModule,
    MmButtonModule,
    MmIconModule,
    AdvancedFormModule,
    MmAlertModule,
  ],
  declarations: [EmployeeOverviewNavigationAlertDialogComponent],
  exports: [EmployeeOverviewNavigationAlertDialogComponent],
})
export class AppEmployeeOverviewNavigationAlertDialogModule {}
